import axios from 'axios'
import interceptorsSetup from '@/helpers/interceptors'

const baseURL = process.env.VUE_APP_API_URL_V3 + '/shipmentVolume'

const shipmentVolume = axios.create({
  baseURL
})

interceptorsSetup(shipmentVolume)

export default class ShipmentVolume {
  static async getTable (shipmentQuery) {
    const result = await shipmentVolume.get('/', {
      params:
      {
        start: shipmentQuery.start,
        end: shipmentQuery.end
      }
    })
    return result.data
  }
  static async getAllowed () {
    const result = await shipmentVolume.get('/consignees')
    return result.data
  }
  static async createShipment (shipment) {
    const result = await shipmentVolume.post('/', shipment)
    return result.data
  }
  static async updateShipment (shipment) {
    const result = await shipmentVolume.post('/update', shipment)
    return result.data
  }
  static async archiveShipment (shipment) {
    const result = await shipmentVolume.put('/archive/' + shipment)
    return result.data
  }
}
